<template>
  <div class="anunt2-container1">
    <app-navigation
      imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
      rootClassName="navigationroot-class-name14"
    ></app-navigation>
    <main class="anunt2-main">
      <div id="transport" class="anunt2-hero section-container">
        <div class="anunt2-max-width1 max-content-container">
          <div class="anunt2-content-container">
            <h1 class="anunt2-text10">
              <span>
                COMBINATUL AUTO
                <span v-html="rawi5kf"></span>
              </span>
              <span class="anunt2-text12">nr.4</span>
              <br />
              <span class="anunt2-text14">s</span>
              <span class="anunt2-text15">
                ervicii de
                <span v-html="rawqzzg"></span>
              </span>
              <br />
              <span class="anunt2-text17">calitate</span>
              <br />
              <span class="anunt2-text18">
                IN
                <span v-html="raw2t2h"></span>
              </span>
              <span class="anunt2-text19">Moldova</span>
            </h1>
            <span class="anunt2-text20">
              <span>N</span>
              <span class="anunt2-text22">
                oi garantam executarea rapida și la un nivel
                <span v-html="raw13s2"></span>
              </span>
              <br />
              <span class="anunt2-text24">
                inalt a comenzilor Dvs.
                <span v-html="rawsfwp"></span>
              </span>
            </span>
            <div class="anunt2-btns-container1">
              <a
                href="https://combinatulauto.md/#servicii"
                target="_blank"
                rel="noreferrer noopener"
                class="anunt2-primary1 button-primary button-lg button"
              >
                servicii
              </a>
              <a
                href="https://combinatulauto.md/#contacts"
                target="_blank"
                rel="noreferrer noopener"
                class="anunt2-secondary button button-outline button-lg-border"
              >
                adresa noastra
              </a>
            </div>
          </div>
          <div class="anunt2-video-container">
            <div class="anunt2-container2"></div>
          </div>
        </div>
        <div class="anunt2-blue-background"></div>
      </div>
      <div class="anunt2-text-content">
        <h2 class="anunt2-text25">
          <span>
            ADUNAREA GENERALA
            <span v-html="rawij84"></span>
          </span>
          <br />
          <span>EXTRAORDINARA </span>
          <span>A ACTIONARILOR 2023</span>
          <br />
        </h2>
      </div>
      <div class="anunt2-blog">
        <iframe
          src="https://drive.google.com/file/d/1HCDP8ZXZYGYnOA9urLGLxOvcpT9lKvGi/preview"
          class="anunt2-iframe"
        ></iframe>
      </div>
      <div class="anunt2-container3">
        <div class="anunt2-btns-container2">
          <router-link
            to="/news"
            class="anunt2-primary2 button-primary button-lg button"
          >
            vezi toate noutatile
          </router-link>
        </div>
      </div>
      <div class="anunt2-numbers-banner section-container">
        <div class="anunt2-container4 max-content-container">
          <div class="anunt2-heading-container1">
            <span class="anunt2-text31">
              Personalul intreprinderii reprezinta o echipa profesionista, cu
              experienta vasta in domeniu.
              <span v-html="raw62fh"></span>
            </span>
            <h1 class="anunt2-text32 Heading2">
              <span>
                servicii la preturi accesibile
                <span v-html="rawf096"></span>
              </span>
            </h1>
          </div>
          <div class="anunt2-numbers-container">
            <numbers-card text="expeditiii"></numbers-card>
            <numbers-card
              text="ani"
              number="12"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
            <numbers-card
              text="evenimente"
              number="64"
              imageSrc="/interface%20calendar%20favorite-200h.webp"
            ></numbers-card>
            <numbers-card
              text="companii"
              number="234"
              imageSrc="/shopping%20bag%20suit%20case-200h.webp"
            ></numbers-card>
            <numbers-card
              text="orase"
              number="14"
              imageSrc="/travel%20map%20location%20pin-200h.webp"
            ></numbers-card>
            <numbers-card
              text="diagnosticari"
              number="1,071"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
          </div>
        </div>
      </div>
      <div class="anunt2-previous-events section-container">
        <div class="anunt2-max-width2 max-content-container">
          <div class="anunt2-heading-container2">
            <h1 class="anunt2-text34 Heading2">
              <span>PARTENERUL TAU DE INCREDERE</span>
            </h1>
            <span class="anunt2-text36">
              garantam executarea rapida si calitativa a comenzilor Dumneavoastra
            </span>
          </div>
        </div>
      </div>
    </main>
    <app-footer rootClassName="footerroot-class-name14"></app-footer>
  </div>
</template>

<script>
import AppNavigation from '../components/navigation'
import NumbersCard from '../components/numbers-card'
import AppFooter from '../components/footer'

export default {
  name: 'Anunt2',
  props: {},
  components: {
    AppNavigation,
    NumbersCard,
    AppFooter,
  },
  data() {
    return {
      rawi5kf: ' ',
      rawqzzg: ' ',
      raw2t2h: ' ',
      raw13s2: ' ',
      rawsfwp: ' ',
      rawij84: ' ',
      raw62fh: ' ',
      rawf096: ' ',
    }
  },
  metaInfo: {
    title: 'Anunt-2 - SA Combinatul Auto Nr.4 din Chișinău',
    meta: [
      {
        name: 'description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:title',
        content: 'Anunt-2 - SA Combinatul Auto Nr.4 din Chișinău',
      },
      {
        property: 'og:description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:image',
        content:
          'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/7df3687e-9d61-4851-bd9b-b6ae978e2570/ea494eb0-6cf8-464c-b070-cddce041bc5c?org_if_sml=1&q=80&force_format=original',
      },
    ],
  },
}
</script>

<style scoped>
.anunt2-container1 {
  width: 100%;
  display: flex;
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  align-items: center;
  flex-direction: column;
}
 
.anunt2-main {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
 
.anunt2-hero {
  position: relative;
  padding-top: 128px;
}
 
.anunt2-max-width1 {
  z-index: 1;
  align-items: stretch;
}
 
.anunt2-content-container {
  flex: 1;
  display: flex;
  max-width: 45%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
 
.anunt2-text10 {
  font-size: 60px;
  font-style: normal;
  font-family: IBM Plex Sans Condensed;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: var(--dl-space-space-unit);
  text-transform: uppercase;
  text-decoration: none;
}
 
.anunt2-text12 {
  text-transform: lowercase;
}
 
.anunt2-text14 {
  color: var(--dl-color-scheme-pink);
}
 
.anunt2-text15 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.anunt2-text17 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.anunt2-text18 {
  font-style: normal;
  font-weight: 600;
  text-transform: lowercase;
}
 
.anunt2-text19 {
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
}
 
.anunt2-text20 {
  font-style: normal;
  font-weight: 500;
  margin-bottom: 42px;
}
 
.anunt2-text22 {
  text-transform: lowercase;
}
 
.anunt2-text24 {
  text-transform: lowercase;
}
 
.anunt2-btns-container1 {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
}
 
.anunt2-primary1 {
  margin-right: var(--dl-space-space-oneandhalfunits);
  text-decoration: none;
}
 
.anunt2-secondary {
  text-decoration: none;
}
 
.anunt2-video-container {
  flex: 1;
  width: 200px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
 
.anunt2-container2 {
  width: 100%;
  height: 511px;
  display: flex;
  transition: 0.3s;
  background-size: cover;
  background-image: url("/home-1200h.webp");
  background-position: center;
}
 
.anunt2-container2:hover {
  transform: scale(1.02);
  box-shadow: 5px 5px 10px 0px rgba(111, 102, 102, 0.31);
}
 
.anunt2-blue-background {
  top: 0px;
  right: 0px;
  width: 47%;
  height: 100px;
  position: absolute;
  min-height: 80%;
  background-size: cover;
  background-image: url("/blue-bg-1500w.webp");
  background-repeat: no-repeat;
}
 
.anunt2-text-content {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-twounits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  justify-content: space-between;
}
 
.anunt2-text25 {
  font-size: 3rem;
  text-align: center;
}
 
.anunt2-blog {
  width: 100%;
  height: var(--dl-size-size-maxwidth);
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: var(--dl-size-size-maxwidth);
  align-self: center;
  align-items: center;
  padding-top: 50px;
  padding-bottom: 52px;
  justify-content: space-between;
}
 
.anunt2-iframe {
  width: 1110px;
  height: var(--dl-size-size-maxwidth);
}
 
.anunt2-container3 {
  width: 100%;
  height: 243px;
  display: flex;
  align-items: center;
  justify-content: center;
}
 
.anunt2-btns-container2 {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
}
 
.anunt2-primary2 {
  width: 364px;
  padding-right: var(--dl-space-space-halfunit);
  text-decoration: none;
}
 
.anunt2-numbers-banner {
  display: flex;
  padding-top: var(--dl-space-space-fiveunits);
  flex-direction: column;
  background-size: cover;
  background-image: url("/29bg-1500w.webp");
}
 
.anunt2-container4 {
  flex-direction: column;
}
 
.anunt2-heading-container1 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.anunt2-text31 {
  color: var(--dl-color-scheme-white);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.anunt2-text32 {
  color: var(--dl-color-scheme-white);
  text-align: center;
}
 
.anunt2-numbers-container {
  width: 100%;
  display: grid;
  grid-row-gap: var(--dl-space-space-fourunits);
  grid-column-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}
 
.anunt2-previous-events {
  display: flex;
  position: relative;
  flex-direction: column;
  padding-bottom: 150px;
}
 
.anunt2-max-width2 {
  flex-direction: column;
}
 
.anunt2-heading-container2 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.anunt2-text34 {
  text-align: center;
}
 
.anunt2-text36 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
@media(max-width: 991px) {
  .anunt2-max-width1 {
    flex-direction: column;
  }
  .anunt2-content-container {
    max-width: 100%;
    margin-bottom: 42px;
  }
  .anunt2-container2 {
    width: 583px;
  }
  .anunt2-blue-background {
    top: auto;
    width: 100%;
    bottom: 0px;
    min-height: 40%;
  }
  .anunt2-blog {
    flex-direction: column;
  }
  .anunt2-numbers-container {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
 
@media(max-width: 767px) {
  .anunt2-container2 {
    width: 505px;
  }
  .anunt2-text-content {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .anunt2-blog {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .anunt2-numbers-container {
    grid-template-columns: 1fr 1fr;
  }
  .anunt2-previous-events {
    padding-bottom: var(--dl-space-space-sixunits);
  }
}
 
@media(max-width: 479px) {
  .anunt2-text10 {
    font-size: 60px;
  }
  .anunt2-container2 {
    width: 424px;
  }
  .anunt2-text-content {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .anunt2-blog {
    height: 515px;
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .anunt2-iframe {
    width: var(--dl-size-size-xxlarge);
    height: 100%;
  }
}
</style>
